import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/services/supabaseClient'
import { isAdminEmail } from '@/utils/userAccess'
import WebAdminPanel from '@/web-admin/index'

export default function WebAdminPage() {
  const navigate = useNavigate()
  const [authorized, setAuthorized] = useState(false)
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (!user || !isAdminEmail(user.email ?? '')) {
        navigate('/login', { replace: true })
      } else {
        setAuthorized(true)
      }
      setChecking(false)
    })
  }, [navigate])

  if (checking) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #f0f4ff, #faf5ff)',
        fontFamily: 'Inter, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>🌐</div>
          <div style={{ fontWeight: 700, color: '#4c1d95', fontSize: '16px' }}>Checking permissions...</div>
        </div>
      </div>
    )
  }

  if (!authorized) return null

  return <WebAdminPanel />
}
